import Dexie from 'dexie'

import Component from 'vue-class-component';
import { Vue } from 'vue-property-decorator';
import moment from 'moment'
import { Cow } from '@/interfaces/Cow';


@Component
class DexieService extends Vue {
    $db: any
    updateSyncLength() {
        this.$db.syncs.count().then((count: number) => {
            this.$store.state.openSyncs = count;
        });
    }

    dbUpdateAllSelected(allSelected: any) {
        this.$db.cows.toArray((cows: any) => {
            cows.forEach((cow: any) => {
                const selected = allSelected.map((c: Cow) => c.id).includes(cow.id) ? true : false;
                this.$db.cows.update(
                    cow.id,
                    { selected}
                )
            })
        })
    }
}
export default DexieService;
